import service from "@/utils/axios-v2";

export function paymentSettingWAddUser(data) {
  return service({
    url: "/fuel-fleet/fleet/driver/fleet/payment/switch/batch",
    method: "POST",
    data,
    headers: {
      "portal-token": true,
    },
  });
}

export function getDriverPaymentSetting(data) {
  return service({
    baseURL: process.env.VUE_APP_TP_URL,
    url: "/fuel-fleet/fleet/payment/driver/list",
    method: "POST",
    data,
    headers: {
      "portal-token": true,
    },
  });
}

export function getAccountWalletInfo(data) {
  return service({
    url: "/fuel-fleet/fleet/payment/treasury/account/info",
    method: "POST",
    data,
    headers: {
      "portal-token": true,
    },
  });
}

export function createWalletAccount(data) {
  return service({
    url: "/fuel-fleet/fleet/payment/create/treasury/account",
    method: "POST",
    data,
    headers: {
      "portal-token": true,
    },
  });
}

export function isDriverInBlacklist(driverId) {
  return service({
    url: `/fuel-fleet/fleet/payment/driver/blackList/driverId?driverId=${driverId}`,
    method: "GET",
    headers: {
      "portal-token": true,
    },
  });
}

export function isUserInBlacklist(tpUserId) {
  return service({
    url: `/fuel-fleet/fleet/payment/driver/blackList/tpUserId?tpUserId=${tpUserId}`,
    method: "GET",
    headers: {
      "portal-token": true,
    },
  });
}

/**
 *
 * @param {
 *    "companyId": 1,
 *    "driverId": 1
 * } deleteList
 *
 */
export function deleteWalletPaymentSetting(deleteList) {
  return service({
    url: "fuel-fleet/fleet/update/driver/payment/settings/delete/batch",
    method: "POST",
    data: deleteList,
    headers: {
      "portal-token": true,
    },
  });
}
